(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["market-country-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('market-localization')) {
    customElements.define('market-localization', class extends HTMLElement {
      connectedCallback() {
        this.events?.abort();
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        const details = this.querySelector('details');
        const toggle = this.querySelector('summary');
        const close = (restoreFocus = false) => {
          details.open = false;
          if (restoreFocus) toggle.focus();
        };
        details.addEventListener('toggle', () => {
          toggle.setAttribute('aria-expanded', String(details.open));
          if (details.open) {
            document.querySelectorAll('market-localization details[open]').forEach(other => {
              if (other !== details) other.open = false;
            });
          } else {
            this.querySelector('form').reset();
          }
        }, options);
        this.querySelector('form').addEventListener('submit', event => {
          // Shopify CLI serves language-prefixed GET routes but cannot handle this localization POST.
          if (!['127.0.0.1', 'localhost'].includes(window.location.hostname)) return;
          const form = event.currentTarget;
          const selectedCountry = form.querySelector('[name="country_code"]:checked')?.value;
          const currentCountry = Array.from(form.querySelectorAll('[name="country_code"]')).find(input => input.defaultChecked)?.value;
          if (selectedCountry !== currentCountry) return;
          const language = form.querySelector('[name="language_code"]:checked')?.value?.toLowerCase();
          const prefixes = { en: '', 'zh-cn': '/zh-cn', 'zh-tw': '/zh-tw', ms: '/ms' };
          if (!Object.hasOwn(prefixes, language)) return;
          event.preventDefault();
          const url = new URL(window.location.href);
          const basePath = url.pathname.replace(/^\/(?:zh-hans|zh-hant|zh-cn|zh-tw|ms)(?=\/|$)/i, '') || '/';
          url.pathname = `${prefixes[language]}${basePath === '/' ? '' : basePath}` || '/';
          try { window.localStorage.setItem('torras_preferred_locale', language); } catch (error) { /* Storage may be unavailable. */ }
          window.location.assign(`${url.pathname}${url.search}${url.hash}`);
        }, options);
        this.addEventListener('keydown', event => {
          if (event.key === 'Escape' && details.open) {
            event.preventDefault();
            event.stopPropagation();
            close(true);
          }
        }, options);
        document.addEventListener('click', event => {
          if (!this.contains(event.target)) close();
        }, options);
        this.addEventListener('focusout', event => {
          if (event.relatedTarget && !this.contains(event.relatedTarget)) close();
        }, options);
      }
      disconnectedCallback() { this.events?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["partner-finder"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
    var trigger = event.target.closest('[data-partner-finder-toggle]');
    if (!trigger) return;
    var panel = document.getElementById(trigger.getAttribute('aria-controls'));
    if (!panel) return;
    var expanded = trigger.getAttribute('aria-expanded') === 'true';
    trigger.setAttribute('aria-expanded', String(!expanded));
    panel.hidden = expanded;
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pdp-fixed-recommendations"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pdp-fixed-recommendations')) {
    customElements.define('pdp-fixed-recommendations', class extends HTMLElement {
      connectedCallback() {
        if (this.closest('quick-add-modal')) return;
        this.form = document.getElementById(this.dataset.formId);
        if (!this.form) return;
        this.mainVariants = JSON.parse(this.querySelector('[data-pairing-main-variants]').textContent);
        this.onChange = () => this.sync();
        this.onClick = (event) => {
          const button = event.target.closest('[data-pairing-step], [data-pairing-swatch]');
          if (!button || button.disabled || this.querySelector('fieldset').disabled) return;
          const item = button.closest('[data-pairing-item]');
          if (button.dataset.pairingSwatch) {
            item.querySelector('[data-pairing-variant]').value = button.dataset.pairingSwatch;
          } else {
            item.dataset.quantity = String(Math.max(0, Number(item.dataset.quantity) + Number(button.dataset.pairingStep)));
          }
          this.sync();
        };
        this.addEventListener('click', this.onClick);
        this.form.addEventListener('change', this.onChange);
        this.form.addEventListener('input', this.onChange);
        this.addEventListener('change', this.onChange);
        this.submitButton = this.form.querySelector('[type="submit"]');
        this.observer = new MutationObserver(() => this.sync());
        if (this.submitButton) this.observer.observe(this.submitButton, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
        this.hidden = false;
        this.sync();
      }

      disconnectedCallback() {
        this.form?.removeEventListener('change', this.onChange);
        this.form?.removeEventListener('input', this.onChange);
        this.removeEventListener('change', this.onChange);
        this.removeEventListener('click', this.onClick);
        this.observer?.disconnect();
      }

      sync() {
        const mainId = this.form.querySelector('[name="id"]')?.value;
        const available = !!this.mainVariants[mainId] && !this.submitButton?.disabled;
        this.querySelector('fieldset').disabled = !available;
        const inputs = this.querySelector('[data-pairing-inputs]');
        inputs.replaceChildren();
        let count = 0;
        let totalQuantity = 0;
        this.querySelectorAll('[data-pairing-item]').forEach(item => {
          const select = item.querySelector('[data-pairing-variant]');
          const option = select.selectedOptions[0];
          item.querySelector('[data-pairing-price]').textContent = option?.dataset.price || '';
          const maximum = Math.min(Number(option.dataset.max), Number(option.dataset.ruleMax || Infinity));
          const quantity = Math.min(maximum, Math.max(0, Number(item.dataset.quantity) || 0));
          item.dataset.quantity = String(quantity);
          item.querySelector('[data-pairing-check]').checked = quantity > 0;
          item.querySelector('[data-pairing-quantity]').textContent = quantity;
          item.querySelector('[data-pairing-step="-1"]').disabled = quantity === 0;
          item.querySelector('[data-pairing-step="1"]').disabled = quantity >= maximum;
          item.querySelectorAll('[data-pairing-swatch]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.pairingSwatch === select.value)));
          const image = item.querySelector('img');
          if (image && option.dataset.image && image.getAttribute('src') !== option.dataset.image) {
            image.removeAttribute('srcset');
            image.src = option.dataset.image;
          }
          if (!available || !quantity) return;
          count += 1;
          totalQuantity += quantity;
          for (const [key, value] of Object.entries({ id: select.value, quantity: String(quantity) })) {
            const input = document.createElement('input');
            input.type = 'hidden';
            input.setAttribute('form', this.form.getAttribute('id'));
            input.name = `shopify-additional-items[${count}][${key}]`;
            input.value = value;
            if (key === 'id') input.dataset.quantity = String(quantity);
            inputs.append(input);
          }
        });
        const status = this.querySelector('[data-pairing-status]');
        status.textContent = !available ? status.dataset.unavailable : count ? status.dataset.selected.replace('[count]', totalQuantity) : status.dataset.none;
      }

      appendToCartData(formData) {
        const selected = this.querySelectorAll('[data-pairing-inputs] input[name$="[id]"]');
        if (!selected.length) return false;
        const original = [...formData.entries()];
        for (const [key, value] of original) {
          if (key.startsWith('shopify-additional-items[')) {
            formData.delete(key);
          } else if (['id', 'quantity', 'selling_plan'].includes(key)) {
            formData.delete(key);
            formData.append(`items[0][${key}]`, value);
          } else if (key.startsWith('properties[')) {
            formData.delete(key);
            formData.append(`items[0][properties]${key.slice(10)}`, value);
          }
        }
        if (!formData.has('items[0][quantity]')) formData.append('items[0][quantity]', '1');
        selected.forEach((input, index) => {
          formData.append(`items[${index + 1}][id]`, input.value);
          formData.append(`items[${index + 1}][quantity]`, input.dataset.quantity);
        });
        return true;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
